import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Summary = styled.section`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: 1rem;
    padding: 1.2rem;
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    background: ${p => p.theme.background};
    color: ${p => p.theme.color};

    p, h4, h5 {
        margin: 0;
    }
`;

const PaymentSplit = styled.p`
    grid-column: 1 / -1;
`;

const eur = value => `€ ${Number(value || 0).toFixed(2)}`;

export default function New_Offer_Price_Summary(props) {
    const { t } = useTranslation();

    return (
        <Summary aria-label={t('Offer price summary')}>
            <div>
                <p>{t('Net amount')}</p>
                <h5>{eur(props.netAmount)}</h5>
            </div>
            <div>
                <p>{t('VAT amount')}</p>
                <h5>{eur(props.vatAmount)}</h5>
            </div>
            <div>
                <p>{t('Total including VAT')}</p>
                <h4>{eur(props.totalAmount)}</h4>
            </div>
            {props.hasRecurringPayments ? (
                <PaymentSplit>
                    {`${t('Recurring payment')}: ${eur(props.recurringAmount)} ${t('/ 30 days')}`}
                    {props.hasOneOffPayments ? ` · ${t('One-off payment')}: ${eur(props.oneOffAmount)}` : ''}
                </PaymentSplit>
            ) : null}
        </Summary>
    );
}
